// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__8p8FF","box":"styles_box__lV7su","icon":"styles_icon__LWG0b"};